import api from './api';

/** Triggers a browser download from a blob API response. */
const triggerDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
};

const download = async (path, fileName) => {
  const response = await api.get(path, { responseType: 'blob' });
  triggerDownload(response.data, fileName);
};

const procurementDocumentsService = {
  // Request for Quotation
  listRfqs: (purchaseRequestId) =>
    api.get('/procurement-documents/rfq', { params: { purchase_request_id: purchaseRequestId } }),
  getRfq: (id) => api.get(`/procurement-documents/rfq/${id}`),
  createRfq: (data) => api.post('/procurement-documents/rfq', data),
  updateRfq: (id, data) => api.put(`/procurement-documents/rfq/${id}`, data),
  downloadRfqPdf: (id, fileName) => download(`/procurement-documents/rfq/${id}/pdf`, fileName),
  downloadRfqDocx: (id, fileName) => download(`/procurement-documents/rfq/${id}/docx`, fileName),

  // Competitive Analysis
  listCompetitiveAnalyses: (purchaseRequestId) =>
    api.get('/procurement-documents/competitive-analysis', { params: { purchase_request_id: purchaseRequestId } }),
  getCompetitiveAnalysis: (id) => api.get(`/procurement-documents/competitive-analysis/${id}`),
  createCompetitiveAnalysis: (data) => api.post('/procurement-documents/competitive-analysis', data),
  updateCompetitiveAnalysis: (id, data) => api.put(`/procurement-documents/competitive-analysis/${id}`, data),
  downloadCompetitiveAnalysisPdf: (id, fileName) =>
    download(`/procurement-documents/competitive-analysis/${id}/pdf`, fileName),
  downloadCompetitiveAnalysisDocx: (id, fileName) =>
    download(`/procurement-documents/competitive-analysis/${id}/docx`, fileName),

  // Purchase Order
  listPurchaseOrders: (purchaseRequestId) =>
    api.get('/procurement-documents/purchase-orders', { params: { purchase_request_id: purchaseRequestId } }),
  getPurchaseOrder: (id) => api.get(`/procurement-documents/purchase-orders/${id}`),
  createPurchaseOrder: (data) => api.post('/procurement-documents/purchase-orders', data),
  updatePurchaseOrder: (id, data) => api.put(`/procurement-documents/purchase-orders/${id}`, data),
  downloadPurchaseOrderPdf: (id, fileName) => download(`/procurement-documents/purchase-orders/${id}/pdf`, fileName),
  downloadPurchaseOrderDocx: (id, fileName) => download(`/procurement-documents/purchase-orders/${id}/docx`, fileName),

  // Goods Received Note
  listGrns: (purchaseRequestId) =>
    api.get('/procurement-documents/grn', { params: { purchase_request_id: purchaseRequestId } }),
  getGrn: (id) => api.get(`/procurement-documents/grn/${id}`),
  createGrn: (data) => api.post('/procurement-documents/grn', data),
  updateGrn: (id, data) => api.put(`/procurement-documents/grn/${id}`, data),
  downloadGrnPdf: (id, fileName) => download(`/procurement-documents/grn/${id}/pdf`, fileName),
  downloadGrnDocx: (id, fileName) => download(`/procurement-documents/grn/${id}/docx`, fileName),
};

export default procurementDocumentsService;
